import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import EmailVerifyModal from './EmailVerifyModal'
import { StyledTextField, checkLowerCase, checkSpecialChars, checkUppercase } from './FirstRegisterStepV2'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CircleIcon from '@mui/icons-material/Circle'
import ErrorIcon from '@mui/icons-material/Error'
import { isValidEmail } from '../../libs/utils'
import { MutateCreateAccountV3, MutateGenerateVerificationCode, MutateVerifyEmail } from '../../libs/hooks/mutations'
import ErrorAlert from '../../Layouts/ErrorAlert'
import { useNavigate } from 'react-router'
import InputMask from 'react-input-mask'
import RegistrationSuccessPopup from './RegistrationSuccessPopup'

const RegisterPageV3 = () => {
  // Component logic goes here
  const [showVerifyModal, setShowVerifyModal] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [showPasswordChecks, setShowPasswordChecks] = useState(false)
  const [payload, setPayload] = useState({
    productId: '511801',
    distributorId: 5184,
    agentFirstName: null,
    agentLastName: null,
    agentPhone: null,
    agentEmail: null,
    agentNPN: null,
    agentID: null,
    password: null,
    confirmPassword: null,
    purpose: 'CG',
  })
  const [errors, setErrors] = useState({
    agentFirstName: false,
    agentLastName: false,
    agentEmail: false,
    agentNPN: false,
    agentID: false,
    password: false,
    confirmPassword: false,
    agreeToTerms: false,
    agentPhone: false,
  })
  const [errorMessages, setErrorMessages] = useState({
    agentFirstName: '',
    agentLastName: '',
    agentEmail: '',
    agentNPN: '',
    agentID: '',
    password: '',
    confirmPassword: '',
    agentPhone: '',
  })
  const [verifiedEmail, setVerifiedEmail] = useState(false)
  const [codeGenerated, setCodeGenerated] = useState(false)
  const [verificationError, setVerificationError] = useState(false)
  const [showErrors, setShowErrors] = useState(false)
  const [error, setError] = useState({
    msgText: '',
    msgTitle: '',
  })
  const [showCreateAccountError, setShowCreateAccountError] = useState(false)
  const [agreedCheckbox, setAgreedCheckbox] = useState(false)
  const [RegistrationSuccess, setRegistrationSuccess] = useState(false)

  const navigate = useNavigate()

  const {
    mutate: generateCode,
    data: generateCodeRes,
    isError: isGenerateCodeError,
    error: generateCodeError,
  } = MutateGenerateVerificationCode()
  const { mutate: verifyEmail, data: verifyEmailRes, isError: isVerifyError, error: verifyError } = MutateVerifyEmail()
  const {
    mutate: createAccount,
    data: createAccountRes,
    isError: isCreateAccountError,
    error: createAccountError,
    isPending: creatingAccount,
  } = MutateCreateAccountV3()

  useEffect(() => {
    return () => setRegistrationSuccess(false)
  }, [])

  useEffect(() => {
    if (!generateCodeRes) return
    console.log({ generateCodeRes })
    if (generateCodeRes.statusCode === 200) {
      setCodeGenerated(true)
      setShowVerifyModal(true)
    }

    return () => {
      setCodeGenerated(false)
    }
  }, [generateCodeRes])

  useEffect(() => {
    if (!verifyEmailRes) return
    console.log({ verifyEmailRes })
    if (verifyEmailRes.statusCode === 200) {
      setVerificationError(false)
      setVerifiedEmail(payload.agentEmail)
      setShowVerifyModal(false)
    } else {
      setVerificationError(true)
    }
  }, [verifyEmailRes])

  useEffect(() => {
    if (isCreateAccountError || !createAccountRes) {
      if (createAccountError) {
        setError({ msgText: createAccountError.msgText, msgTitle: createAccountError.msgTitle })
        return setShowCreateAccountError(true)
      }
      return
    }
    console.log({ createAccountRes })
    setRegistrationSuccess(true)
    setPayload({
      productId: '511801',
      distributorId: 5184,
      agentFirstName: null,
      agentLastName: null,
      agentPhone: null,
      agentEmail: null,
      agentNPN: null,
      agentID: null,
      password: null,
      confirmPassword: null,
      purpose: 'CG',
    })
  }, [createAccountRes, isCreateAccountError])

  const getIcon = (isChecked) => {
    const smallDotIcon = <CircleIcon sx={{ fontSize: '0.3rem !important', color: '#56677B' }} />
    const checkCircleIcon = <CheckCircleIcon sx={{ fontSize: '0.8rem !important', color: '#3C4FB9' }} />
    const iconToBeRendered = isChecked ? checkCircleIcon : smallDotIcon

    return (
      <div
        style={{
          height: '20px',
          width: '15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {iconToBeRendered}
      </div>
    )
  }

  const prepareHelperText = (value) => {
    const firstIcon = getIcon(value?.length >= 12)
    const secondIcon = getIcon(checkUppercase(value))
    const thirdIcon = getIcon(checkLowerCase(value))
    const fourthIcon = getIcon(checkSpecialChars(value))
    const fifthIcon = getIcon(
      value === payload.confirmPassword && value?.length > 0 && payload.confirmPassword?.length > 0
    )

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {firstIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 12 characters
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {secondIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 1 uppercase letter
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {thirdIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 1 lowercase letter
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {fourthIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Must contain at least 1 of the following characters: !@#$%^&*()
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          {fifthIcon}
          <Typography fontSize={'12px'} color="#56677B">
            Passwords must match
          </Typography>
        </div>
      </div>
    )
  }

  const handleChange = (e) => {
    setPayload({ ...payload, [e.target.name]: e.target.value })
  }

  const handleVerifyEmail = () => {
    if (payload.agentEmail.length < 5 || !isValidEmail(payload.agentEmail))
      return setErrors({ ...errors, agentEmail: true })
    if (!codeGenerated || payload.agentEmail !== verifiedEmail) {
      generateCode({
        affiliateCode: `CG${payload.agentID}`,
        email: payload.agentEmail,
        productId: 511801,
        firstName: payload.agentFirstName,
      })
    }
  }

  const handleResendCode = () => {
    console.log('Resendingg')
    generateCode({
      affiliateCode: `CG${payload.agentID}`,
      email: payload.agentEmail,
      productId: 511801,
      firstName: payload.agentFirstName,
    })
  }

  const handleBlur = ({ target: { name, value } }) => {
    switch (name) {
      case 'agentNPN':
        if (value.length === 0) {
          setErrorMessages((prev) => ({ ...prev, agentNPN: 'NPN is a required field' }))
          setErrors((prev) => ({
            ...prev,
            agentNPN: true,
          }))
        } else {
          setErrorMessages((prev) => ({ ...prev, agentNPN: '' }))
          setErrors((prev) => ({
            ...prev,
            agentNPN: false,
          }))
        }
        break

      case 'agentID':
        if (value.length === 0) {
          setErrorMessages((prev) => ({ ...prev, agentID: 'CG Producer Number is a required field' }))
          setErrors((prev) => ({
            ...prev,
            agentID: true,
          }))
        } else {
          setErrorMessages((prev) => ({ ...prev, agentID: '' }))
          setErrors((prev) => ({
            ...prev,
            agentID: false,
          }))
        }
        break

      case 'agentFirstName':
        if (value.length === 0) {
          setErrorMessages((prev) => ({ ...prev, agentFirstName: 'First Name is a required field' }))
          setErrors((prev) => ({
            ...prev,
            agentFirstName: true,
          }))
        } else {
          setErrorMessages((prev) => ({ ...prev, agentFirstName: '' }))
          setErrors((prev) => ({
            ...prev,
            agentFirstName: false,
          }))
        }
        break

      case 'agentLastName':
        if (value.length === 0) {
          setErrorMessages((prev) => ({ ...prev, agentLastName: 'Last Name is a required field' }))
          setErrors((prev) => ({
            ...prev,
            agentLastName: true,
          }))
        } else {
          setErrorMessages((prev) => ({ ...prev, agentLastName: '' }))
          setErrors((prev) => ({
            ...prev,
            agentLastName: false,
          }))
        }
        break

      case 'agentEmail':
        setVerificationError(false)
        if (value.length !== 0) {
          if (isValidEmail(value) === false) {
            setErrorMessages((prev) => ({ ...prev, agentEmail: 'Please enter a valid email address' }))
            setErrors((prev) => ({
              ...prev,
              agentEmail: !isValidEmail(value),
            }))
          } else {
            setErrorMessages((prev) => ({ ...prev, agentEmail: '' }))
            setErrors((prev) => ({
              ...prev,
              agentEmail: false,
            }))
          }
        } else {
          setErrorMessages((prev) => ({ ...prev, agentEmail: 'Work Email Address is a required field' }))
          setErrors((prev) => ({
            ...prev,
            agentEmail: true,
          }))
        }

        break

      case 'password':
        if (value.length < 12 || !checkUppercase(value) || !checkLowerCase(value) || !checkSpecialChars(value)) {
          console.log('password error')
          return setErrors((prev) => {
            return { ...prev, password: true }
          })
        } else {
          setErrors((prev) => {
            return { ...prev, password: false }
          })
        }

        if (payload.confirmPassword?.length !== 0) {
          if (value !== payload.confirmPassword) {
            return setErrors((prev) => {
              return { ...prev, confirmPassword: true }
            })
          } else {
            setErrors((prev) => {
              return { ...prev, confirmPassword: false }
            })
          }
        }

        break

      case 'confirmPassword':
        if (payload.password !== value || value.length === 0) {
          return setErrors((prev) => {
            return { ...prev, confirmPassword: true }
          })
        } else {
          setErrors((prev) => {
            return { ...prev, confirmPassword: false }
          })
        }
        break
      case 'agentPhone':
        if (value.replace(/[^0-9]/g, '').length !== 0) {
          if (value.replace(/[^0-9]/g, '').length < 10 || value.replace(/[^0-9]/g, '').length > 10) {
            console.log('PHONE IS INVALID')
            setErrorMessages((prev) => ({ ...prev, agentPhone: 'Please enter a valid phone number' }))
            setErrors((prev) => ({ ...prev, [name]: true }))
          } else {
            setErrors((prev) => ({ ...prev, [name]: false }))
          }
        } else {
          setErrorMessages((prev) => ({ ...prev, agentPhone: 'Mobile Phone Number is a required field' }))
          setErrors((prev) => ({ ...prev, [name]: true }))
        }
        break
      default:
        setErrors((prev) => ({ ...prev, [name]: !value || value.trim() === '' }))
        break
    }
  }

  const emailVerified = payload.agentEmail === verifiedEmail

  const handleCreateAccount = () => {
    if (Object.values(errors).some((error) => error)) {
      setShowErrors(true)
      return
    }

    if (!emailVerified) {
      setErrors((prev) => ({ ...prev, agentEmail: true }))
      setShowErrors(true)
      return
    }

    let nullCheckPass = true
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || (typeof payload[key] === 'string' && payload[key].trim() === '')) {
        setErrors((prev) => ({ ...prev, [key]: true }))
        nullCheckPass = false
        return
      }
    })
    console.log({ nullCheckPass })
    if (nullCheckPass) {
      setShowErrors(false)
      console.log('I am here!!')
      delete payload.confirmPassword
      let pld = { ...payload }
      pld.agentPhone = pld.agentPhone.replace(/[^0-9]/g, '')
      createAccount(pld)
    } else {
      setShowErrors(true)
    }
  }

  useEffect(() => {
    console.log(errors)
  }, [errors])

  return (
    <>
      <ErrorAlert
        showError={showCreateAccountError}
        setShowError={setShowCreateAccountError}
        msgTitle={error.msgTitle}
        messageText={error.msgText}
      />
      <RegistrationSuccessPopup
        show={RegistrationSuccess}
        setShow={setRegistrationSuccess}
        affiliateCode={payload.agentID}
      />
      <Box sx={registerStyle.containerBox}>
        <Typography variant="h4" align="center" sx={{ mt: '6px', mb: '6px' }}>
          Create an Account
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ mt: '6px', mx: '10px', fontFamily: 'Roboto !important' }}>
          Register now to access and manage your products and applications on your NewBridge Portal.
        </Typography>
        <Box component="form" sx={{ '& .MuiTextField-root': { m: 1 }, width: '100%' }} noValidate autoComplete="off">
          <Typography align={'left'} sx={registerStyle.subheading}>
            Login Information
          </Typography>
          <Grid container spacing={1} justifyContent={'center'}>
            <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="National Producer Number (NPN)"
                  type="number"
                  name="agentNPN"
                  value={payload.agentNPN}
                  onChange={(e) => {
                    handleChange(e)
                    // setInvalidAgtId(false)
                    // setAgtIdMsg('')
                    // handleRegistrationFormChange(e)
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={registerStyle.textField}
                  required
                  onBlur={handleBlur}
                  error={showErrors && errors.agentNPN}
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                  InputProps={{
                    inputProps: {
                      inputMode: 'numeric',
                    },
                    endAdornment: (
                      <Tooltip
                        arrow
                        placement="top"
                        title={
                          <Box p={1}>
                            <Typography variant="body2">Locate your NPN at nipr.com</Typography>
                          </Box>
                        }
                      >
                        <InfoOutlinedIcon />
                      </Tooltip>
                    ),
                  }}
                />
                {showErrors && errors.agentNPN && (
                  <Box display="flex" ml={1} gap={1} alignItems={'flex-start'}>
                    <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

                    <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
                      {errorMessages.agentNPN}
                    </Typography>
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="Continental General Producer Number"
                  type="number"
                  name="agentID"
                  value={payload.agentID}
                  onChange={(e) => {
                    handleChange(e)
                    // setInvalidAgtId(false)
                    // setAgtIdMsg('')
                    // handleRegistrationFormChange(e)
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={registerStyle.textField}
                  required
                  onBlur={handleBlur}
                  error={showErrors && errors.agentID}
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                  InputProps={{
                    inputProps: {
                      inputMode: 'numeric',
                    },
                  }}
                />
                {showErrors && errors.agentID && (
                  <Box display="flex" ml={1} gap={1} alignItems={'flex-start'}>
                    <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

                    <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
                      {errorMessages.agentID}
                    </Typography>
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="First Name"
                  name="agentFirstName"
                  value={payload.agentFirstName}
                  onChange={(e) => {
                    handleChange(e)
                    // setInvalidAgtId(false)
                    // setAgtIdMsg('')
                    // handleRegistrationFormChange(e)
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={registerStyle.textField}
                  required
                  onBlur={handleBlur}
                  error={showErrors && errors.agentFirstName}
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
                {showErrors && errors.agentFirstName && (
                  <Box display="flex" ml={1} gap={1} alignItems={'flex-start'}>
                    <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

                    <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
                      {errorMessages.agentFirstName}
                    </Typography>
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="Last Name"
                  name="agentLastName"
                  value={payload.agentLastName}
                  onChange={(e) => {
                    handleChange(e)
                    // setInvalidAgtId(false)
                    // setAgtIdMsg('')
                    // handleRegistrationFormChange(e)
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={registerStyle.textField}
                  required
                  onBlur={handleBlur}
                  error={showErrors && errors.agentLastName}
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
                {showErrors && errors.agentLastName && (
                  <Box display="flex" ml={1} gap={1} alignItems={'flex-start'}>
                    <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

                    <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
                      {errorMessages.agentLastName}
                    </Typography>
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <InputMask
                  mask="(999) 999-9999"
                  onChange={(e) => {
                    handleChange(e)
                    // setInvalidAgtId(false)
                    // setAgtIdMsg('')
                    // handleRegistrationFormChange(e)
                  }}
                  onBlur={handleBlur}
                  value={payload.agentPhone}
                >
                  {(inputProps) => (
                    <TextField
                      {...inputProps}
                      id="outlined-disabled"
                      label="Mobile Phone Number"
                      type="phone"
                      name="agentPhone"
                      InputLabelProps={{ shrink: true }}
                      sx={registerStyle.textField}
                      required
                      error={showErrors && errors.agentPhone}
                      // helperText={invalidAgtId ? agtIdMsg : ''}
                    />
                  )}
                </InputMask>
                {showErrors && errors.agentPhone && (
                  <Box display="flex" ml={1} gap={1} alignItems={'flex-start'}>
                    <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

                    <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
                      {errorMessages.agentPhone}
                    </Typography>
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={10} md={10} sm={10} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="Work Email Address (Login)"
                  name="agentEmail"
                  value={payload.agentEmail}
                  onChange={(e) => {
                    handleChange(e)
                    // setInvalidAgtId(false)
                    // setAgtIdMsg('')
                    // handleRegistrationFormChange(e)
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={registerStyle.textField}
                  required
                  onBlur={handleBlur}
                  error={(showErrors && errors.agentEmail) || isGenerateCodeError}
                  // helperText={isGenerateCodeError ? generateCodeError.msgText : ''}
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
                {(isGenerateCodeError || (showErrors && errors.agentEmail)) && (
                  <Box display="flex" ml={1} gap={1} alignItems={'flex-start'}>
                    <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

                    <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
                      {errors.agentEmail ? errorMessages.agentEmail : generateCodeError?.msgText}
                    </Typography>
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={12} pl={'0!important'} alignItems={'center'} justifyContent={'center'}>
              <Button
                sx={{
                  textTransform: 'none',
                  width: { lg: '90%', md: '90%', sm: '90%', xs: '100%' },
                  height: '40px',
                  backgroundColor: '#C4CAF1',
                  color: '#3C4FB9',
                  borderRadius: '100px',
                  mt: { sm: '15px', xs: '0px' },
                  '&:hover': {
                    backgroundColor: '#9BA5DF',
                    color: '#36414E',
                  },
                  '&:disabled': {
                    backgroundColor: Boolean(emailVerified) ? '#EFFBFA' : '#C4CAF1',
                    color: Boolean(emailVerified) ? '#259A92' : 'white',
                    textTransform: 'none',
                    border: Boolean(emailVerified) ? '1px solid #259A92' : 'none',
                    fontSize: Boolean(emailVerified) ? '12px' : 'normal',
                  },
                }}
                onClick={handleVerifyEmail}
                disabled={Boolean(emailVerified) || errors.agentEmail}
              >
                {Boolean(emailVerified) ? 'Verified!' : 'Verify'}
              </Button>
            </Grid>
            {emailVerified && (
              <>
                <Grid item lg={6} xs={12} md={6} pl={'0!important'}>
                  <FormControl>
                    <StyledTextField
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          '&.MuiInputLabel-shrink': {
                            backgroundColor: '#F5F7FF',
                          },
                        },
                      }}
                      label="Password"
                      value={payload.password}
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      required
                      //   onBlur={handleBlur}
                      onChange={(e) => handleChange(e)}
                      onFocus={() => setShowPasswordChecks(true)}
                      error={showErrors && errors.password}
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      onBlur={handleBlur}
                      // focused={password !== ""}
                    />
                  </FormControl>
                </Grid>
                <Grid item lg={6} xs={12} md={6} pl={'0!important'}>
                  <FormControl>
                    <StyledTextField
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          '&.MuiInputLabel-shrink': {
                            backgroundColor: '#F5F7FF',
                          },
                        },
                      }}
                      required
                      label="Confirm Password"
                      value={payload.confirmPassword}
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      onBlur={handleBlur}
                      onChange={(e) => handleChange(e)}
                      error={showErrors && errors.confirmPassword}
                      InputProps={{
                        // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                              {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      // focused={confirmPassword !== ""}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Box width={'100%'} gap={'1px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Checkbox
                      label="terms-check"
                      required
                      checked={agreedCheckbox}
                      onClick={() => {
                        setAgreedCheckbox(!agreedCheckbox)
                        setErrors({
                          ...errors,
                          agreeToTerms: !!agreedCheckbox,
                        })
                      }}
                    />
                    <Typography fontSize={'14px'}>
                      I agree to the{' '}
                      <a href="https://www.afficiency.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                        Terms of Service
                      </a>{' '}
                      and{' '}
                      <a href="https://www.afficiency.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                      </a>
                    </Typography>
                  </Box>
                </Grid>
              </>
            )}
            {showPasswordChecks && (
              <Grid item xs={12}>
                {prepareHelperText(payload.password)}
              </Grid>
            )}
            <Grid item lg={5} md={6} sm={12} xs={12} pl={'0!important'}>
              <Button
                sx={registerStyle.verifyButton}
                onClick={handleCreateAccount}
                disabled={!agreedCheckbox || !emailVerified}
                // disabled={!formIsComplete || !errorFree || !agreedCheckbox || invalidUrl}
              >
                {creatingAccount ? <CircularProgress size={'20px'} /> : 'Create Account'}
              </Button>
            </Grid>
          </Grid>
          <EmailVerifyModal
            show={showVerifyModal}
            setShow={setShowVerifyModal}
            email={payload.agentEmail}
            handleResend={handleResendCode}
            isVerifyError={isVerifyError || verificationError}
            verifyEmail={verifyEmail}
          />
        </Box>
      </Box>
    </>
  )
}

const registerStyle = {
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: { lg: '626px', md: '770px', sm: '770px', xs: '343px' },
    maxWidth: { lg: '522px', md: '770px', sm: '770px', xs: '343px' },
    height: 'auto',
    background: '#F5F7FF',
    margin: '100px auto',
    padding: { lg: '64px 60px', md: '40px 32px ', sm: '40px 32x', xs: '16px' },
  },
  textField: {
    backgroundColor: 'white',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    },
  },
  subheading: {
    padding: '30px 0px 15px 0px',
  },
  verifyButton: {
    textTransform: 'none',
    width: { lg: '90%', md: '90%', sm: '90%', xs: '60%' },
    height: '40px',
    mt: { sm: '15px', xs: '0px' },
    backgroundColor: '#C4CAF1',
    color: '#3C4FB9',
    borderRadius: '100px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
    submitBtn: {
      textTransform: 'none',
      width: { lg: '10%', md: '20%', sm: '30%', xs: '60%' },
      height: '40px',
      mt: { sm: '15px', xs: '0px' },
      backgroundColor: '#C4CAF1',
      color: '#3C4FB9',
      borderRadius: '100px',
      '&:hover': {
        backgroundColor: '#9BA5DF',
        color: '#36414E',
      },
      '&:disabled': {
        backgroundColor: '#C4CAF1',
        color: 'white',
        textTransform: 'none',
      },
    },
  },
}

export default RegisterPageV3